// StoreSelector.tsx (веб)
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import styles from "./StoreSelector.module.scss";
import { selectForceStores, selectStoreList } from "../../../../../store/slices/storeListSlice";
import { selectCurrentCluster } from "../../../../../store/slices/currentClusterSlice";
import { useTheme } from "../../../../hooks/useTheme";
import SelectableCard from "../selectableCard/SelectableCard";


interface StoreSelectorProps {
  handlePickUpStoreChange: (id: number) => void;
  pickUpStore?: number;
}

const StoreSelector = ({
  handlePickUpStoreChange,
  pickUpStore,
}: StoreSelectorProps) => {
  const storeList = useSelector(selectStoreList);
  const currentCluster = useSelector(selectCurrentCluster);
  const selectedStoreIds = useSelector(selectForceStores);
  const forceStore = currentCluster?.forceStore ?? false;
  const { theme } = useTheme();

  // Фильтруем точки: при forceStore показываем только выбранную
  const visibleStores = useMemo(() => {
    if (forceStore && selectedStoreIds.length > 0) {
      const selectedStoreId = selectedStoreIds[0];
      return storeList.filter((store) => store.id === selectedStoreId);
    }
    return storeList;
  }, [storeList, forceStore, selectedStoreIds]);

  return (
    <div className={styles.container}>
      <h3 className={styles.title} style={{ color: theme.text }}>
        Точка самовывоза
      </h3>
      <div className={styles.optionsContainer}>
        {visibleStores.map((el) => (
          <SelectableCard
            key={el.id}
            isSelected={pickUpStore === el.id}
            onSelect={() => handlePickUpStoreChange(Number(el.id))}
            label={`${el.name} ${el.city?.value || ""} ${el?.address?.value || ""}`}
            className={styles.optionCard}
            small
          />
        ))}
      </div>
    </div>
  );
};

export default StoreSelector;
